<template>
  <base-dialog v-if="isLoading" title="Wait for a moment..." @close="ClickDialogClose">
    <template #default>
      <p>Wait for a moment whilst we are preparing the app...</p>
      <p>Thank you</p>
    </template>
  </base-dialog>

  <div>
    <div class="flex-container">
      <div class="flex-child" role="group">
        <ul>
          <li v-for="(item, index) in assetOptions" :key="item.value">
            <fchq-assets :item="item" :id="index" @asset-selected="SelectAsset"></fchq-assets>
          </li>
        </ul>
      </div>
    </div>
    <transition name="fade" mode="out-in">
      <base-card v-show="key !== ''">
        <div class="row justify-content-between mb-3">
          <div class="col">
            <h5 class="tm_title text-start" style="margin-bottom: 4px !important;">{{ venuename }}</h5>
          </div>
          <div class="col">
            <h5 class="tm_title text-end" style="margin-top: 0px !important;" v-if="capacity">Capacity: {{ capacity }}</h5>
          </div>
        </div>
        <div>
          <div class="fchq" v-show="showIncluded">
            <fchq-included :configuration="pickedVenueDetails" @config-picked="ConfigPicked"></fchq-included>
          </div>

          <div class="fchq" v-show="key == 'commnunityhub'">
            <fchq-layouts :configuration="pickedVenueDetails" @config-picked="ConfigPicked"></fchq-layouts>
          </div>
          <div class="fchq" v-show="key == 'audio' || key == 'margaretRoom' || key == 'goughRoom' || key == 'workaryOpenSpaceArea' || key == 'meetRoom' || key == 'wetherill'">
            <fchq-equirements :configuration="pickedVenueDetails" @config-picked="ConfigPicked"></fchq-equirements>
          </div>
          <div class="fchq" v-show="key == 'studio'">
            <studio-includes :configuration="pickedVenueDetails" @config-picked="ConfigPicked"></studio-includes>
          </div>
        </div>
      </base-card>
    </transition>
  </div>
</template>
<script>
import { venuesAPI } from '../../../../config';
import { MEETING, COMMUNITY, CREATIVE } from '../data';
import FchqAssets from '@/components/whitlam-calendar/pages/FchqAssets';
import FchqLayouts from '@/components/whitlam-calendar/pages/fchq/FchqLayouts';
import FchqIncluded from '@/components/whitlam-calendar/pages/fchq/FchqIncluded';
import FchqEquirements from '@/components/whitlam-calendar/pages/fchq/FchqEquirements';
import StudioIncludes from '@/components/whitlam-calendar/pages/whitlam/studioIncludes';
import BaseCard from '../UI/BaseCard.vue';

export default {
  props: ['solutions'],
  components: { FchqAssets, FchqLayouts, FchqEquirements, FchqIncluded, BaseCard, StudioIncludes},
  inject: [
    'addResourceMethod',
    'getBookingDetails',
    'resources',
    'setSelectedTag',
  ],
  data() {
    return {
      token: '',
      key: '',
      venuename: '',
      capacity: '',
      showIncluded: false,
      pickedConfiguration: [],
      pickedVenueDetails: null,

      includedInfo: [],

      assetOptions: [],
      equipments: null,
      isLoading: false,

      // assetGroups: FCHQ,
      assetWGroups: MEETING,
      assetsCommunity: COMMUNITY,
      assetsCreative: CREATIVE
    };
  },
  mounted() {
    if (this.$router.currentRoute._rawValue.query.page === 'meeting-rooms') {
      for (const opt in MEETING) {
        // { text: 'Dedicated Hot Desks', value: '100115899', key: 'hotdesksdd' },
        let item = { text: MEETING[opt].venueName, value: opt, key: opt };
        this.assetOptions.push(item);
      }
    }
    if (this.$router.currentRoute._rawValue.query.page === 'community-spaces') {
      for (const opt in COMMUNITY) {
        // { text: 'Dedicated Hot Desks', value: '100115899', key: 'hotdesksdd' },
        let item = { text: COMMUNITY[opt].venueName, value: opt, key: opt };
        this.assetOptions.push(item);
      }
    }
    if (this.$router.currentRoute._rawValue.query.page === 'creative-studio') {
      for (const opt in CREATIVE) {
        // { text: 'Dedicated Hot Desks', value: '100115899', key: 'hotdesksdd' },
        let item = { text: CREATIVE[opt].venueName, value: opt, key: opt };
        this.assetOptions.push(item);
      }
    }
  },

  watch: {
    key() {
      // console.log(this.key);
      const keys = ['hotdesksdd', 'hotdesks', 'meetingrooms', 'bingLee', 'jonEnglish', 'harryKewell', 'learnRoom', 'bonnyrigg']; // also empty key to make sure when no selection pick, nothing shows up
      this.showIncluded = keys.includes(this.key);
      // console.log(this.showIncluded)
    },
  },

  methods: {
    ConfigPicked(config) {
      this.pickedConfiguration = +config;
      // console.log(config)
      this.$emit('venues-selected', {
        VenueDetails: this.pickedVenueDetails,
        PickedConfig: this.pickedConfiguration,
      });
    },

    SelectAsset(opt) {
      // console.log(opt);
      if (this.$router.currentRoute._rawValue.query.page === 'meeting-rooms') {

        this.includedInfo = this.assetWGroups[opt.key].whatisincluded;
        this.key = opt.key;
        // console.log(this.key);
        this.venuename = this.assetWGroups[opt.key].venueName;
        this.capacity = this.assetWGroups[opt.key].maxCapacity;
        // console.log(this.capacity);
        //TODO request asset here

        // this.loadEquipments();
        this.pickedVenueDetails = this.assetWGroups[this.key];

        // console.log('this is venue details', this.pickedConfiguration);

        this.$emit('venues-selected', {
          VenueDetails: this.pickedVenueDetails,
          PickedConfig: this.pickedConfiguration,
        });
      }
      if (this.$router.currentRoute._rawValue.query.page === 'community-spaces') {

        this.includedInfo = this.assetsCommunity[opt.key].whatisincluded;
        this.key = opt.key;
        // console.log(this.key);
        this.venuename = this.assetsCommunity[opt.key].venueName;
        this.capacity = this.assetsCommunity[opt.key].maxCapacity;

        //TODO request asset here

        // this.loadEquipments();
        this.pickedVenueDetails = this.assetsCommunity[this.key];

        // console.log('this is venue details', this.pickedConfiguration);

        this.$emit('venues-selected', {
          VenueDetails: this.pickedVenueDetails,
          PickedConfig: this.pickedConfiguration,
        });
      }
      if (this.$router.currentRoute._rawValue.query.page === 'creative-studio') {

        this.includedInfo = this.assetsCreative[opt.key].whatisincluded;
        this.key = opt.key;
        // console.log(this.key);
        this.venuename = this.assetsCreative[opt.key].venueName;
        this.capacity = this.assetsCreative[opt.key].maxCapacity;

        //TODO request asset here

        // this.loadEquipments();
        this.pickedVenueDetails = this.assetsCreative[this.key];

        // console.log('this is venue details', this.pickedConfiguration);

        this.$emit('venues-selected', {
          VenueDetails: this.pickedVenueDetails,
          PickedConfig: this.pickedConfiguration,
        });
      }
    },

    loadEquipments() {
      var myHeaders = new Headers();
      myHeaders.append('Content-Type', 'application/json');
      myHeaders.append('Authorization', 'Bearer ' + this.token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        //body: facility,
      };

      fetch(venuesAPI, requestOptions)
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          if (data.result != undefined) {
            // make sure array not empty.
            this.equipments = data.result;
            this.isLoading = false;

            // console.log('equipments: ', this.equipments);
          } else {
            //  console.log('equipments, no data: ', data);
          }
        })
        .catch((error) => {
          console.log('error', error);
        });
    },
  },
};
</script>

<style scoped>
label {
  font-weight: bold;
  margin-right: 2rem;
}

input,
textarea {
  font: inherit;
  padding: 0.15rem;
  border: 1px solid #ccc;
}

input:focus,
textarea:focus {
  outline: none;
  border-color: #9cb161;
  background-color: #f7ebff;
}

ul {
  list-style-type: none;
  padding: 0;
}

.whatisincluded {
  font-weight: lighter;
  font-size: 90%;
}

.form-control {
  margin: 1rem 0;
}

.radiobtxt {
  font-weight: bold;
  /* display: block; */
  margin-bottom: 0.5rem;
}

/* .fchq {
  margin-top: 3rem;
} */

.flex-container {
  display: flex;
}

.tm_title {
  text-align: center;
}

.flex-list {
  flex: 1;
  border: 2px solid #fff;
}

.fade-enter-active {
  transition: opacity 0.5s ease-in-out;
}

.fade-enter-from {
  opacity: 0;
}

/* .flex-child-menu {
  border: 2px solid rgb(255, 255, 255);
} */

@media (max-width: 768px) {
  .flex-child {
    margin: 0rem;
    width: 100%;
  }
}
</style>
